type Props = { props: Record<string, string | number | boolean> }

export function CtaPreview({ props: p }: Props) {
  return (
    <div className="flex flex-col items-center gap-2 py-2">
      <button
        className="w-full max-w-xs py-3 px-6 rounded-lg text-white font-bold text-sm"
        style={{ backgroundColor: p.acceptColor as string }}
      >
        {p.acceptText as string}
      </button>
      <button className="text-sm underline" style={{ color: p.declineColor as string }}>
        {p.declineText as string}
      </button>
    </div>
  )
}
